interface SetCheckedProduct {
  type: 'SET_CHECKED_PRODUCT'
  productId: string
  checked: boolean
}

interface SetProductComment {
  type: 'SET_PRODUCT_COMMENT'
  productId: string
  value: string
}

interface SetProductCommentsForEditingToggled {
  type: 'SET_PRODUCT_COMMENTS_TO_EDITING_TOGGLED'
  productId: string
  toggled: boolean
}

interface SetProductCommentsForEditing {
  type: 'SET_PRODUCT_COMMENTS_FOR_EDITING'
  productId: string
  comments: string[]
}

interface SetIsSubmitting {
  type: 'SET_IS_SUBMITTING'
  isSubmitting: boolean
}

interface SetSubmitErrors {
  type: 'SET_SUBMIT_ERRORS'
  errors: string[]
}

interface ResetProduct {
  type: 'RESET_PRODUCT'
  productId: string
}

type Action =
  | SetCheckedProduct
  | SetProductComment
  | SetProductCommentsForEditingToggled
  | SetProductCommentsForEditing
  | SetIsSubmitting
  | SetSubmitErrors
  | ResetProduct

interface State {
  checkedProducts: { [productId: string]: boolean | undefined }
  productComments: { [productId: string]: string | undefined }
  productCommentsForEditingToggled: { [productId: string]: boolean | undefined }
  productCommentsForEditing: { [productId: string]: string[] | undefined }
  isSubmitting: boolean
  submitErrors: string[]
}

export const initialState: State = {
  checkedProducts: {},
  productComments: {},
  productCommentsForEditingToggled: {},
  productCommentsForEditing: {},
  isSubmitting: false,
  submitErrors: [],
}

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_CHECKED_PRODUCT': {
      return {
        ...state,
        checkedProducts: {
          ...state.checkedProducts,
          [action.productId]: action.checked,
        },
      }
    }
    case 'SET_PRODUCT_COMMENT': {
      return {
        ...state,
        productComments: {
          ...state.productComments,
          [action.productId]: action.value,
        },
      }
    }
    case 'SET_PRODUCT_COMMENTS_TO_EDITING_TOGGLED': {
      return {
        ...state,
        productCommentsForEditingToggled: {
          ...state.productCommentsForEditingToggled,
          [action.productId]: action.toggled,
        },
      }
    }
    case 'SET_PRODUCT_COMMENTS_FOR_EDITING': {
      return {
        ...state,
        productCommentsForEditing: {
          ...state.productCommentsForEditing,
          [action.productId]: action.comments,
        },
      }
    }
    case 'SET_IS_SUBMITTING': {
      return {
        ...state,
        isSubmitting: action.isSubmitting,
      }
    }
    case 'SET_SUBMIT_ERRORS': {
      return {
        ...state,
        submitErrors: action.errors,
      }
    }
    case 'RESET_PRODUCT': {
      return {
        ...state,
        checkedProducts: {
          ...state.checkedProducts,
          [action.productId]: undefined,
        },
        productComments: {
          ...state.productComments,
          [action.productId]: undefined,
        },
        productCommentsForEditingToggled: {
          ...state.productCommentsForEditingToggled,
          [action.productId]: undefined,
        },
        productCommentsForEditing: {
          ...state.productCommentsForEditing,
          [action.productId]: undefined,
        },
      }
    }
    default:
      throw new Error(`Unknown action ${JSON.stringify(action)}`)
  }
}

export default reducer
